import * as olStyle from 'ol/style';
import Point from 'ol/geom/Point';
import { getVuetifyThemeVar } from '@/utils/mapLayerTheme';
import { withOpacity } from '@/utils/map/olColor';

const getThemeVar = getVuetifyThemeVar;

export function createMarkerStyle(markerName) {
  return new olStyle.Style({
    image: new olStyle.Icon({
      anchor: [0.5, 1],
      anchorXUnits: 'fraction',
      anchorYUnits: 'fraction',
      src: 'img/icons/imagePos.png',
      scale: 0.7,
      opacity: 0.7
    }),
    text: new olStyle.Text({
      font: 'bold 12px/1.2 \'Courier New\'',
      text: markerName,
      offsetY: -15,
      fill: new olStyle.Fill({
        color: getThemeVar('--v-surface-base', '#FFFFFF'),
        width: 4
      }),
      stroke: new olStyle.Stroke({
        color: getThemeVar('--v-text-base', 'black'),
        width: 2
      })
    })
  });
}

export function createRecommendMarkerStyle(markerName) {
  return new olStyle.Style({
    image: new olStyle.Icon({
      anchor: [0.5, 1.1],
      scale: 0.11,
      anchorXUnits: 'fraction',
      anchorYUnits: 'fraction',
      src: 'img/icons/recommendPin.png'
    }),
    text: new olStyle.Text({
      font: 'bold 12px/1.2 \'Courier New\'',
      text: markerName,
      offsetY: -15,
      fill: new olStyle.Fill({
        color: getThemeVar('--v-surface-base', '#FFFFFF'),
        width: 4
      }),
      stroke: new olStyle.Stroke({
        color: getThemeVar('--v-text-base', 'black'),
        width: 2
      })
    })
  });
}

export function getArrowStyle(feature) {
  const geometry = feature.getGeometry();
  const styles = [
    new olStyle.Style({
      stroke: new olStyle.Stroke({
        color: getThemeVar('--v-warning-base', '#E65100'),
        width: 2
      }),
      text: new olStyle.Text({
        textAlign: undefined,
        textBaseline: 'middle',
        font: 'bold 12px/1.2 \'Courier New\'',
        text: feature.get('name'),
        fill: new olStyle.Fill({ color: getThemeVar('--v-success-base', '#2E7D32') }),
        stroke: new olStyle.Stroke({ color: getThemeVar('--v-surface-base', '#ffffff'), width: 3 }),
        offsetX: 0,
        offsetY: 0,
        placement: 'point',
        backgroundFill: new olStyle.Fill({
          color: withOpacity(getThemeVar('--v-surface-base', '#ffffff'), 0.7)
        }),
        maxAngle: 45,
        overflow: true,
        rotation: 0
      })
    })
  ];

  geometry.forEachSegment((start, end) => {
    const dx = end[0] - start[0];
    const dy = end[1] - start[1];
    const rotation = Math.atan2(dy, dx);
    styles.push(
      new olStyle.Style({
        geometry: new Point(end),
        image: new olStyle.Icon({
          src: 'img/icons/arrow.png',
          anchor: [0.75, 0.5],
          rotateWithView: true,
          rotation: -rotation
        })
      })
    );
  });

  return styles;
}
